namespace TabAurous.OMS {
    export interface StatesMasterRow {
        Id?: number;
        StateName?: string;
        CountryId?: number;
    }

    export namespace StatesMasterRow {
        export const idProperty = 'Id';
        export const nameProperty = 'StateName';
        export const localTextPrefix = 'OMS.StatesMaster';
        export const lookupKey = 'OMS.StatesMaster';

        export function getLookup(): Q.Lookup<StatesMasterRow> {
            return Q.getLookup<StatesMasterRow>('OMS.StatesMaster');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            StateName = "StateName",
            CountryId = "CountryId"
        }
    }
}
